import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import useReduxPopupSystem from 'src/new_arch/hooks/useReduxPopupSystem';
import useSnackbarSystem from '@ui/systems/useSnackbarSystem';
import { leaveProjects } from 'src/actions/projects';
import Project from 'src/entities/workspaceProject';
import AsyncActionPresenterFactory from 'src/factories/AsyncActionPresenterFactory';
import { fetchWorkspaceProjects } from 'src/actions/workspaceProjects';

const useLeaveWorkspaceProject = ( { project }: { project: Project } ) => {
	const dispatch = useDispatch();
	const popupSystem = useReduxPopupSystem();
	const snackbarSystem = useSnackbarSystem();

	const onLeaveProjectClick = useCallback( () => AsyncActionPresenterFactory.forLeaveProjects( {
		leaveProjects: ( projectIDs: number[] ) => (
			( dispatch( leaveProjects( projectIDs ) ) as unknown as Promise<unknown> ).then(
				() => dispatch( fetchWorkspaceProjects( project.workspaceID ) )
			)
		),
		projectsIDs: [ project.id ],
		leftProjectName: project.name,
		popupSystem,
		snackbarSystem
	} ).trigger(), [ project.id, project.name, popupSystem, snackbarSystem ] );

	return onLeaveProjectClick;
}

export default useLeaveWorkspaceProject;
